import { initFirebase, firebaseAnalytics } from "../config/firebaseConfig"
import gaJSON from "../config/googleAnalytics.json"
import { getAnalytics, logEvent, setUserId } from "firebase/analytics"
import { getDeviceProperties } from "./userHelpers"

const trackFirebaseAnalytics = ({ event, params = undefined }) => {
  const additionalProps = getDeviceProperties()
  params = {
    ...params,
    // Add additional parameters as needed for your analytics events
    ...additionalProps
  }
  try {
    logEvent(getAnalytics(), event, params)
  } catch (e) {
    console.error("Google Analytics Error- ", e)
  }
}

const setFirebaseAnalyticsUserId = (userId) => {
  try {
    setUserId(getAnalytics(), userId.toString())
  } catch (e) {
    console.error("Google Analytics Error- ", e)
  }
}

const logFirebaseAnalyticsScreenName = (screenName) => {
  if (screenName !== "Loading") {
    try {
      logEvent(getAnalytics(), "screen_view", {
        firebase_screen: screenName,
        firebase_screen_class: screenName
      })
    } catch (e) {
      console.error("Google Analytics Error- ", e)
    }
  }
}

const logPurchase = (currency, value) => {
  try {
    logEvent(getAnalytics(), "purchase", {
      currency: currency,
      value: value
    })
  } catch (e) {
    console.error("Google Analytics Error- ", e)
  }
}

const logClickEvent = (location, interactionType) => {
  logEvent(getAnalytics(), "button_click", {
    buttonType: gaJSON.button_type,
    location: location || window.location.pathname,
    interactionType: interactionType || gaJSON.single_click
  })
}

const initializeFirebaseAnalytics = () => {
  // Perform any necessary initialization or cleanup related to analytics
  // For example, initializing Firebase analytics on mount or performing setup
}

export {
  trackFirebaseAnalytics,
  setFirebaseAnalyticsUserId,
  logFirebaseAnalyticsScreenName,
  initializeFirebaseAnalytics,
  gaJSON,
  logPurchase,
  logClickEvent
}
